/* ==========================================================================
   PREMIUM REVIEWS — фильтрация, раскрытие списка, «полезно»
   ========================================================================== */
(function () {
  'use strict';

  function initReviews(root) {
    var grid = root.querySelector('[data-reviews-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.px-review'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var moreBtn = root.querySelector('[data-reviews-more]');
    var empty = root.querySelector('[data-reviews-empty]');

    var state = { filter: 'all', expanded: false };

    function matches(card) {
      if (state.filter === 'all') return true;
      if (state.filter === 'photo') return card.getAttribute('data-photo') === '1';
      return card.getAttribute('data-rating') === state.filter;
    }

    function apply() {
      var shownCount = 0;

      cards.forEach(function (card) {
        var ok = matches(card);
        var collapsed = card.classList.contains('is-collapsed');

        var visible = ok && (state.expanded || !collapsed || state.filter !== 'all');
        card.classList.toggle('is-hidden', !visible);

        if (visible) shownCount += 1;
        if (visible) card.classList.add('is-revealed');
      });

      if (moreBtn) moreBtn.style.display = state.expanded || state.filter !== 'all' ? 'none' : '';
      if (empty) empty.hidden = shownCount !== 0;

      return shownCount;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        state.filter = chip.getAttribute('data-filter');
        apply();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.expanded = true;
        apply();
        moreBtn.blur();
      });
    }

    root.querySelectorAll('[data-helpful]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var countEl = btn.querySelector('[data-helpful-count]');
        var value = parseInt(countEl ? countEl.textContent : '0', 10) || 0;
        var on = btn.classList.toggle('is-on');
        value += on ? 1 : -1;
        if (countEl) countEl.textContent = String(Math.max(value, 0));
        if (navigator.vibrate && on) {
          try {
            navigator.vibrate(12);
          } catch (err) {
            /* no-op */
          }
        }
      });
    });

    apply();
  }

  function boot() {
    document.querySelectorAll('.px-reviews').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
